import * as React from "react";

import Layout from "../components/layout/Layout";
import Intro from "../components/home/Intro";

import SEO from "../components/base/seo";

export default function IndexPage() {
  return (
    <Layout>
      <Intro />
    </Layout>
  );
}
